import styled from "@emotion/styled/macro";

export const DrawerWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 70vh;
    max-height: 90vh;
    background: #FFFFFF;
    position: relative;
`;

export const DrawerHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    border-bottom: 1px solid #E8E9ED;
    background: #FFFFFF;
    position: sticky;
    top: 0;
    z-index: 10;
`;

export const DrawerTitle = styled.div`
    font-family: Circular;
    font-weight: 500;
    font-size: 16px;
    line-height: 1.265;
    color: #1A1B1D;
`;

export const DrawerCloseButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 8px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    
    &:hover {
        background: #F5F5F7;
    }
    
    &:active {
        background: #E8E9ED;
    }
`;

export const DrawerBody = styled.div`
    flex: 1;
    padding: 20px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 20px;
    min-height: 0;
    -webkit-overflow-scrolling: touch;
`;

export const DocumentSection = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    background: #F8F9FA;
    border-radius: 12px;
    border: 1px solid #E8E9ED;
`;

export const DocumentInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
`;

export const DocumentIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    flex-shrink: 0;
`;

export const DocumentName = styled.div`
    font-family: Circular;
    font-weight: 450;
    font-size: 14px;
    line-height: 1.265;
    color: #1A1B1D;
    flex: 1;
    word-break: break-word;
`;

export const SearchSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const SearchDescription = styled.p`
    font-family: Circular;
    font-weight: 450;
    font-size: 14px;
    line-height: 1.4;
    color: #585D66;
    margin: 0;
`;

export const SearchInputWrapper = styled.div`
    position: relative;
    display: flex;
    align-items: center;
`;

export const SearchInput = styled.input`
    width: 100%;
    height: 48px;
    padding: 0 16px 0 48px;
    border: 1px solid #E8E9ED;
    border-radius: 40px;
    font-family: Circular;
    font-weight: 450;
    font-size: 14px;
    line-height: 1.265;
    color: #1A1B1D;
    background: #FFFFFF;
    outline: none;
    
    &:focus {
        border-color: #1A1B1D;
    }
    
    &::placeholder {
        color: #9097A3;
    }
`;

export const SearchIcon = styled.div`
    position: absolute;
    left: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    pointer-events: none;
    
    svg {
        width: 16px;
        height: 16px;
        
        path {
            stroke: #9097A3;
        }
    }
`;

export const ItemsSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    flex: 1;
`;

export const SectionTitle = styled.div`
    font-family: Circular;
    font-weight: 500;
    font-size: 14px;
    line-height: 1.265;
    color: #1A1B1D;
    padding: 0 4px;
`;

export const ItemsList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 16px;
`;

export const ItemRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    background: #FFFFFF;
    border: 1px solid #E8E9ED;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover {
        background: #F8F9FA;
        border-color: #D0D5DD;
    }
    
    &:active {
        transform: scale(0.98);
        background: #F0F0F0;
    }
`;

export const ItemContent = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    min-width: 0;
`;

export const ItemDetails = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
    min-width: 0;
`;

export const ItemName = styled.div`
    font-family: Circular;
    font-weight: 450;
    font-size: 14px;
    line-height: 1.265;
    color: #1A1B1D;
    display: flex;
    align-items: center;
    gap: 6px;
    width: fit-content;
    max-width: 100%;
    
    &:hover {
        color: #007AFF;
    }
`;

export const ItemNameText = styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex-shrink: 1;
    min-width: 0;
`;

export const CheckboxWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
    flex-shrink: 0;
    
    .ant-checkbox-wrapper {
        margin: 0;
    }
    
    .ant-checkbox {
        border-radius: 6px;
        
        .ant-checkbox-inner {
            border-radius: 6px;
            border-color: #D0D5DD;
            width: 20px;
            height: 20px;
        }
        
        &.ant-checkbox-checked .ant-checkbox-inner {
            background-color: #1A1B1D;
            border-color: #1A1B1D;
        }
        
        &:hover .ant-checkbox-inner {
            border-color: #1A1B1D;
        }
    }
`;

export const EmptyState = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    font-family: Circular;
    font-weight: 450;
    font-size: 14px;
    line-height: 1.4;
    color: #9097A3;
    text-align: center;
    background: #F8F9FA;
    border-radius: 12px;
    border: 1px solid #E8E9ED;
`;

export const SaveButtonContainer = styled.div`
    padding: 16px 20px 20px;
    background: #FFFFFF;
    border-top: 1px solid #E8E9ED;
    position: sticky;
    bottom: 0;
`;

export const SaveButton = styled.button`
    width: 100%;
    height: 48px;
    background: #1A1B1D;
    color: #FFFFFF;
    border: none;
    border-radius: 12px;
    font-family: Circular;
    font-weight: 500;
    font-size: 16px;
    line-height: 1.265;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover {
        background: #2A2B2D;
    }
    
    &:active {
        transform: scale(0.98);
        background: #000000;
    }
    
    &:disabled {
        background: #E8E9ED;
        color: #9097A3;
        cursor: not-allowed;
        transform: none;
    }
`; 